import {
  AuditLog,
  AuditLogData,
  AuditLogRepository,
  DatabaseService,
} from "../core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getAuditLogRepository(
  databaseService: DatabaseService,
): AuditLogRepository {
  return getGenericRepository<AuditLog, AuditLogData>(
    () => DatabaseCollection.AUDIT_LOGS,
    databaseService,
  );
}
